import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppStore } from '../../../store/applicationState';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CssBaseline from '@mui/material/CssBaseline';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { StylesEdit } from '../../StylesEdit';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { ISupportSub } from '../../../store/support/types';
import TextField from '@mui/material/TextField';
import { CreateSupportSub, UpdateSupportSub } from '../../../store/support/actions';

interface PropsType {
  type: 'edit' | 'new';
  position: number;
  data?: ISupportSub | null;
  handleCancel: () => void;
}

export const EditSupportSub: React.FC<PropsType> = ({ type, position, data, handleCancel }) => {
  const [name, setName] = React.useState(data?.name || '');
  const [approved, setApproved] = React.useState(data ? data.approved : 1);
  const [error, setError] = React.useState(false);

  const { Support } = useSelector((store: AppStore) => store);
  const dispatch = useDispatch();

  const classes = StylesEdit();

  const onSubmit = () => {
    if (!name) return setError(true);
    setError(false);
    const callBack = (succ: boolean) => {
      if (succ) {
        handleCancel();
      }
    };
    if (type === 'new') {
      dispatch(
        CreateSupportSub.request({
          data: {
            name,
            approved,
            position,
          },
          callBack,
        })
      );
    }
    if (data && type === 'edit') {
      dispatch(
        UpdateSupportSub.request({
          id: data.id,
          data: {
            name,
            approved,
            position,
          },
          callBack,
        })
      );
    }
  };

  return (
    <Box>
      <CssBaseline />
      <div className={classes.paper}>
        <Box className={classes.header}>
          <Typography component="h1" variant="h5">
            {type === 'new' ? 'Створити підрозділ' : 'Редагувати підрозділ'}
          </Typography>
        </Box>
        <FormControlLabel
          style={{ marginTop: '20px' }}
          control={<Checkbox checked={!!approved} />}
          onChange={() => setApproved(approved ? 0 : 1)}
          label="Публікувати"
        />
        <TextField
          style={{ marginTop: '20px' }}
          required
          size="small"
          id="outlined-basic-name"
          label="Назва"
          variant="outlined"
          value={name}
          error={error && !name}
          className={classes.textField}
          onChange={(event: React.ChangeEvent<{ value: unknown }>) => {
            setName(event.target.value as string);
          }}
        />
        <Box style={{ margin: '20px 0' }}>
          <Button
            variant="contained"
            color="primary"
            className={classes.submit}
            disabled={Support.loading}
            onClick={onSubmit}
            style={{ height: '36px', marginRight: '40px' }}
          >
            {Support.loading ? <CircularProgress size={15} /> : 'Зберегти'}
          </Button>
          <Button variant="outlined" className={classes.submit} onClick={handleCancel} style={{ height: '36px' }}>
            Повернутися
          </Button>
        </Box>
        {error ? (
          <Alert severity="error">
            <AlertTitle>Заповніть поля</AlertTitle>
          </Alert>
        ) : null}
        {Support.errors ? (
          <Alert severity="error">
            <AlertTitle>Сталася помилка</AlertTitle>
          </Alert>
        ) : null}
      </div>
    </Box>
  );
};
